import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IReference } from '@shared/interfaces/reference.interface';

@Component({
    selector: 'app-sidebar-reference-about',
    templateUrl: './sidebar.reference.about.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarReferenceAboutComponent {
  @Input() public reference: IReference;

  constructor() {}
}
